<template>
<div>
    <HeadDetailsGama :titleHead="'Detalhe do Empreendimento'" :btnNewEnterprise="true" v-on:AddNewCreden="AddNewCreden"></HeadDetailsGama>
  <div id="body-details" class="mt-4 ml-2">
     <div id="head-details" class="pt-2">
             <!-- <div class="d-flex">
               <button v-on:click="AddNewCreden" class="btn-new-gru mr-2"><i class="fas fa-plus mr-2"></i>ADICIONAR NOVO</button>
             </div> -->
           </div>
    <table class="table mt-3 table-hover" v-bind:style="[ showHeader ? 'border: 1px solid #dcdede;' : '' ]">
            <thead class="thead-third" v-if="columns">
              <slot name="header"></slot>
              <tr>
                <th class="text-center"  v-for="colTitle in columns" v-bind:key="colTitle" ><span v-html="colTitle"></span></th>
              </tr>
            </thead>
            <thead class="thead-third" v-else>
              <slot name="thead"></slot>
            </thead>
            <tbody>
              <tr v-for="datafor in  datasearching" v-bind:key="datafor.id">
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datafor.credenciada" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datafor.countCorretor.toString()" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datafor.nomeCidade" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datafor.estado" />
                <TableColumn :newState="true" :newStatusNumber="datafor.situacao == 0 ? 1 : 0" :descriptionNewStatus="datafor.situacao == 0 ? 'Ativo' :'Inativo'" v-on:Edit="$emit('edit')" :status="1"  />
                <TableColumn :IsText="true"    v-on:Edit="$emit('edit')" :status="1" :value="datafor.dataCadastro" />
                <td>
                    <b-dropdown variant="link" size="sm" no-caret class="ml-2" boundary="window">
                      <template slot="button-content">
                        <i class="fa fa-trash text-secundary icone-grid icon-ex"></i>
                      </template>
                      <b-dropdown-header><strong>Deseja Deletar?</strong></b-dropdown-header>
                      <b-dropdown-item href="javascript:void(0);" v-on:click="deleteEnterprise(datafor.id)">Sim</b-dropdown-item>
                      <b-dropdown-item href="javascript:void(0);">Não</b-dropdown-item>
                    </b-dropdown>
                </td>
              </tr>
              <tr v-if="dataTable.length == 0">
                <td colspan="7" class="text-center">Sem dados</td>
              </tr>
            </tbody>
    </table>
  </div>
          <b-modal
          hide-footer
          centered
          ref="modalDetails"
          size="xl"
          no-close-on-backdrop
          no-close-on-esc
          id="modalDetails"
          :title="'ADICIONAR IMOBILIÁRIA'"
        >
        <template #modal-title>
                <div class="header-title">ADICIONAR IMOBILIÁRIA</div>
            </template>
         <div class="modal-body-cus p-3">

            <div class="w-25 input-rela">
               <input v-model="buscaImobiliaria" class="form-control  input-paddi w-100 h-100" placeholder="Pesquisar">
               <i class="fas fa-search icon-search"  aria-hidden="true"></i>
            </div>

           <table class="table mt-3 table-hover" v-bind:style="[ showHeader ? 'border: 1px solid #dcdede;' : '' ]">
            <thead class="thead-modal" v-if="columnsModal">
              <slot name="header"></slot>
              <tr>
                <th class="text-center"><input v-on:click="checkAll" type="checkbox" class="inputchecktablee"></th>
                <th class="text-center"  v-for="colTitle in columnsModal" v-bind:key="colTitle" ><span v-html="colTitle"></span></th>
              </tr>
            </thead>
            <thead class="thead-third" v-else>
              <slot name="thead"></slot>
            </thead>
            <tbody>
              <tr v-for="datafor in dataModal" v-bind:key="datafor.id">
                <td class="checkboxtable">
                  <input class="inputchecktable" :id="datafor.id.toString()" type="checkbox">
                </td>
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datafor.nome" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datafor.countCorretor.toString()" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datafor.cidade.nome" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="datafor.cidade.estado.sigla" />
                <TableColumn :newState="true" :newStatusNumber="datafor.situacao == 0 ? 1 : 0" :descriptionNewStatus="datafor.situacao == 0 ? 'Ativo' :'Inativo'" v-on:Edit="$emit('edit')" :status="1"  />
              </tr>
              <tr v-if="dataModal.length == 0">
                <td class="text-center" colspan="6">
                  Sem dados
                </td>
              </tr>
            </tbody>
          </table>
         </div>

        <div class="d-flex justify-content pt-5">
           <button v-on:click="closeModal" class="btn-can largura mr-2">Cancelar</button>
           <button :disabled="dataModal.length == 0" v-on:click="saveLstGuid" class="btn-save largura l-2">Salvar</button>
         </div>
      </b-modal>
</div>

</template>

<script>
import Tabenterprise from './tabenterprise'
export default Tabenterprise
</script>

<style scoped>
.largura{
  width: 20%;
}
.justify-content{
  width: 100%;
  justify-content: center;
}
.btn-can{
  height: 40px;
  background: grey;
  color: white;
  border: none;
  font-weight: bold;
  border-radius: 10px;
}
.btn-save{
  height: 40px;
  background: #008148;
  color: white;
  border: none;
  font-weight: bold;
  border-radius: 10px;
}
#body-details{
  overflow: auto;
    height: 60vh;
}
#head-details{
  display: flex;
  justify-content: space-between;
}

.btn-new-gru:hover{
  color: white;
  background: #008148;
}
.btn-danger {
  color: #fff;
  background-color: #ff4444;
  border-color: #ff4444;
}
.btn-danger:hover {
  color: #fff;
  background-color: #ff1111;
  border-color: #ff0707;
}
.icone-grid {
  font-size: 18px;
  cursor: pointer;
  vertical-align: middle;
}
.icon-search{
  position: absolute;
  top:  10px;
  left: 10px;
}
.btn-new-gru{
  height: 30px;
  width: 181px;
  background: white;
  font-size: 14px;
  color: #008148;
  font-weight: bold;
  border: 1px solid #008148;
  margin: 0px;
  border-radius: 6px;
}
.input-paddi{
  padding-left: 28px;

}
.input-rela{
  position: relative;
}
.icon-ex{
  font-size: 18px;
  cursor: pointer;
  color: grey;
}
.icon-ex:hover{
  color: red;
}
.modal-footer-cus{
  height: 100px;
  display: flex;
  justify-content: end;
  padding: 15px;
  align-items: center;
}
.thead-modal{
  background: #008144;
  color: white;
}
.table-body-over{
  height: 400px;
  overflow: auto;
}
.tdclass{
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.checkboxtable{
  display: flex;
  justify-content: center;
  align-items: center;
}
.inputchecktable{
  height: 20px;
  width: 20px;
}
.inputchecktablee{
  height: 20px;
  width: 20px;
}
.modal-header-cus{
  height: 40px;
  width: 100%;
  background: #008144;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  color: white;
}
.modal-body-cus{
  height: 400px;
  overflow: auto;
  background: white;
  border-bottom: 1px solid #D4D4D4;
}

.modal-body-cus::-webkit-scrollbar-track {
    background-color: #F4F4F4;
}
.modal-body-cus::-webkit-scrollbar {
    width: 6px;
    background: #F4F4F4;
}
.modal-body-cus::-webkit-scrollbar-thumb {
    background: #dad7d7;
    border-radius: 8px;
}

.header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/tabenterprise/tabenterprise.vue